import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import logo from '../assets/logo.png';
import SalesBoardTiles, { londonTime, feedIsStale } from '../components/SalesBoardTiles';

// Full-screen office display. No sidebar. Re-reads the board every minute
// (the figure itself moves every 15), and asks the screen to stay awake.

const REFRESH_MS = 60 * 1000;

const SalesBoardTV = () => {
  const [board, setBoard] = useState(null);
  const [error, setError] = useState('');
  const [clock, setClock] = useState(new Date());

  const load = useCallback(async () => {
    try {
      const res = await api.get('/api/sales/board');
      setBoard(res.data);
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Cannot reach the portal. Retrying every minute.');
    }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, REFRESH_MS);
    const c = setInterval(() => setClock(new Date()), 15 * 1000);
    let lock = null;
    const wake = async () => { try { lock = await navigator.wakeLock?.request('screen'); } catch { /* not supported */ } };
    wake();
    const onVis = () => { if (document.visibilityState === 'visible') { wake(); load(); } };
    document.addEventListener('visibilitychange', onVis);
    return () => { clearInterval(t); clearInterval(c); document.removeEventListener('visibilitychange', onVis); lock?.release?.(); };
  }, [load]);

  const fullScreen = () => document.documentElement.requestFullscreen?.().catch(() => {});

  return (
    <div className="sb-tv">
      <header className="sb-tv-top">
        <div className="sb-tv-logo"><img src={logo} alt="Tranzparts Group Limited" /></div>
        <div className="sb-tv-heading">Sales Board</div>
        <div className="sb-tv-clock">
          {clock.toLocaleDateString('en-GB', { timeZone: 'Europe/London', weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' })}
          <span>{londonTime(clock)}</span>
        </div>
      </header>

      {error && <div className="sb-tv-alert">{error}</div>}
      {board ? <SalesBoardTiles board={board} /> : !error && <div className="loader">Loading</div>}

      <footer className="sb-tv-foot">
        <span className={board && feedIsStale(board) ? 'sb-tv-stale' : ''}>
          {board?.today_updated ? `Updated ${londonTime(board.today_updated)}` : 'Waiting for today\'s first figure'}
          {board && feedIsStale(board) && '. Autovolt feed is late'}
        </span>
        <span className="sb-tv-actions">
          <button type="button" className="sb-tv-btn" onClick={fullScreen}>Full screen</button>
          <Link to="/sales-board" className="sb-tv-btn">Back</Link>
        </span>
      </footer>
    </div>
  );
};

export default SalesBoardTV;
